export enum QueryKeyEnum {
  AchRefunds = 'ach_refunds',
  AchRefundCalculateTotalForTransactions = 'ach_refund_total',
  ActivitySearch = 'activity_search',
  AddressZipState = 'address_zip_state',
  AdjustmentQuote = 'adjustment_quote',
  AdjustmentQuoteCalculatePlanPaymentDetails = 'adjustment_quote_plan_payment_details',
  Agent = 'agent',
  AgentTeams = 'agent_teams',
  AllowedMailTypes = 'allowed_mail_types',
  AppStatus = 'app_status',
  ArchivedVehicle = 'archived_vehicle',
  Bank = 'bank',
  BankConsentDetails = 'bank_consent_details',
  CallDetails = 'call_details',
  CallScript = 'call_script',
  CallPreview = 'call_preview',
  CalculateCommission = 'calculate_commission',
  Cart = 'cart',
  ConfirmRefund = 'confirm_refund',
  CancelPendingsReport = 'cancel_pendings_report',
  CancelRewritesReport = 'cancel_rewrites_report',
  ClaimsByContractNumber = 'claims_by_contract_number',
  ConfirmRewriteDetails = 'confirm_rewrite_details',
  ContactSessionId = 'contact_session_id',
  ContactSessionEvents = 'contact_session_events',
  Contract = 'contract',
  ContractNumber = 'contract_number',
  ContractActivityLogs = 'contract_activity_logs',
  ContractAvailableCancelReasons = 'contract_available_cancel_reasons',
  ContractAvailableWaitingPeriods = 'contract_available_waiting_periods',
  ContractAvailableSurchargesAndOptions = 'contract_available_surcharges_and_options',
  ContractDetailsByPhone = 'contract_details_by_phone',
  ContractTransactions = 'contract_payment',
  ContractDocuments = 'contract_documents',
  ContractRatesByAdjustmentQuoteId = 'contractrates_by_contract_id',
  ContractAchRefundTransactions = 'contract_transactions',
  ContractsRetention = 'contracts_retention',
  ContractCollections = 'contract_collections',
  ContractsWithPrrBreakdown = 'contracts_with_prr_breakdown',
  QuotesRetention = 'quotes_retention',
  Consumer = 'consumer',
  ConsumerActivityLogs = 'consumer_activity_logs',
  ConsumerAnchorSearch = 'consumer_anchor_search',
  ConsumerEasyPayFinancedContracts = 'consumer_easypay_financed_contracts',
  ConsumerContractsWithRoadsideAssistance = 'consumer_contracts_with_roadside_assistance',
  ConsumerMessageActions = 'consumer_message_actions',
  ConsumerSearch = 'consumer_search',
  ConsumerHome = 'consumer_home',
  ConsumerHomeNotes = 'consumer_home_notes',
  ConsumerNotes = 'consumer_notes',
  ConsumerVehicleNotes = 'consumer_vehicle_notes',
  ConsumerVehicleSearch = 'consumer_vehicle_search',
  ConsumerVehicleTransactions = 'consumer_vehicle_transactions',
  ConsumerVehicleQuoteTransactions = 'consumer_vehicle_quote_transactions',
  ConsumerQuoteTransactions = 'consumer_quote_transactions',
  ConsumerQuoteEstimate = 'consumer_quote_estimate',
  ConsumerPendingLocContracts = 'consumer_pending_loc_contracts',
  ConsumerCancellationAcknowledgementContracts = 'consumer_cancellation_acknowledgement_contracts',
  ConsumerCanceledContracts = 'consumer_canceled_contracts',
  ConsumerNonPayContracts = 'consumer_non_pay_contracts',
  ConsumerInexactMileageContracts = 'consumer_inexact_mileage_contracts',
  ConsumerTransferOwnershipContracts = 'consumer_transfer_ownership_oontracts',
  ContractTransmittalEventsErrors = 'contract_transmittal_events_errors',
  DealLogEntries = 'deal_log_entries',
  EcommerceSession = 'ecommerce_session',
  DuplicateSavesReport = 'duplicate_saves_report',
  FulfillmentHistory = 'fulfillment_history',
  FullFundedDetails = 'full-funded-refund-details',
  FundedFullRefundsReport = 'funded_full_refunds_report',
  HomeQuote = 'home_quote',
  HomeQuotesRetention = 'home_quotes_retention',
  HomePlans = 'home_plans',
  HomeCart = 'home_cart',
  HomeAdjustmentPolicy = 'home_adjustment_policy',
  HomeContractClaims = 'home_contract_claims',
  HomeSavedPayments = 'home_saved_payments',
  HomeTransactions = 'home_transactions',
  InitialQuoteWorkflowSteps = 'initial_quote_workflow_steps',
  InProgressFulfillmentsReport = 'in_progress_fulfillments_report',
  InternetLead = 'internet_lead',
  Lead = 'Lead',
  MailLead = 'mail_lead',
  Managers = 'managers',
  ManualTransactionTypes = 'manual_transaction_types',
  UsersByRoleKey = 'users_by_role_key',
  MissingDownPaymentReport = 'missing_down_payment_report',
  MoxyCustomerNumberSearch = 'moxy_customer_number_search',
  MyUser = 'my_user',
  PlanExpirationDetails = 'plan_expiration_details',
  PlanPaymentDetailsCalculate = 'plan_payment_details_calculate',
  PostDateDeclinesReport = 'post_date_declines_report',
  ProjectedFirstPaymentDateCalculate = 'projected_first_payment_date_calculate',
  PreviousAdditionalHolders = 'previous-additional-holders',
  ProRatedRefundBreakdown = 'pro_rated_refund_breakdown',
  ProRatedRefundDetails = 'pro_rated_refund_details',
  ProRatedRefundReport = 'pro_rated_refund_report',
  PlanDefaultSearch = 'plan_default_search',
  PlanDetailsSearch = 'plan_details_search',
  RatesSearch = 'rates_search',
  RecentAIVendorInteraction = 'recent_aivendor_interaction',
  RecentAIVendorLeadInteraction = 'recent_aivendor_lead_interaction',
  RetentionDiscountsEntries = 'retention_discounts_entries',
  RolesV2 = 'roles_v2',
  SalePendingDetails = 'sales_pending',
  SalesPolicy = 'sales_policy',
  Settings = 'settings',
  StateSpecificPermissions = 'state_specific_permission',
  TransferDetails = 'transfer-details',
  TransferOwnerships = 'transfer_ownership',
  User = 'user',
  Users = 'users',
  UserSession = 'user_session',
  Vehicle = 'vehicle',
  VehiclePreviousQuoteOrContract = 'vehicle_previous_quote_or_contract',
  VehicleQuote = 'vehicle_quote',
  VehicleMakes = 'vehicle_makes',
  VehicleModels = 'vehicle_models',
  VehicleServiceShops = 'vehicle_service_shops',
  VehicleTrims = 'vehicle_series',
  VehicleVinDecode = 'vehicle_vin_decode',
  VehicleYears = 'vehicle_years',
  VerificationChecklist = 'verification_checklist',
  HomeVerificationChecklist = 'home_verification_checklist',
  VinAudit = 'vin_audit',
  ZipcodeDetails = 'zip_code_data',
  AdjustmentPolicy = 'adjustment_policy',
  AdjustmentDiff = 'adjustment_diff',
  CarfaxReports = 'carfax_reports',
}
